import { yesNoList } from '@/constants/yesNoList';
export const formColumnList = (ctx) => {
  console.log('ctx.baseFormData', ctx.baseFormData.repairNo);
  return [
    {
      name: '公司',
      prop: 'workOrderCompanyNo',
      type: 'select',
      options: ctx.companyList || [],
      disabled: true,
      // isHidden: ctx.baseFormData.relatedRepairFlag == '1',
    },
    {
      name: '派单部门',
      prop: 'workOrderDepartmentNo',
      type: 'select',
      options:
        ctx.departmentList.filter((item) => {
          return item.value != '';
        }) || [],
      changeMethod: 'changeMethod',
    },
    {
      name: '派单人',
      prop: 'dispatchPersonName',
      type: 'searchTableSpec',
      searchType: 'personnel',
      currentValue: ctx.baseFormData.dispatchPersonName,
      isMultiple: true,
      changeMethod: 'changeMethod',
      extraData: {
        adminFlag: ctx.userInfo.adminFlag,
        dataStatus: 'ZT03',
        personCompanyCode: ctx.baseFormData.workOrderCompanyNo,
        personDepartmentCode: ctx.baseFormData.workOrderDepartmentNo,
      },
    },
    {
      name: '工单名称',
      prop: 'name',
      type: 'input',
    },
    {
      name: '工单类型',
      prop: 'type',
      type: 'select',
      options:
        ctx.setOptions.workOrderType.filter((item) => {
          return item.value != '';
        }) || [],
    },
    {
      name: '是否关联报修单',
      prop: 'relatedRepairFlag',
      type: 'select',
      options: yesNoList || [],
      changeMethod: 'changeMethod',
      // currentValue: ctx.baseFormData.relatedRepairFlag,
    },
    {
      name: '关联报修单号',
      prop: 'repairNo',
      key: 'repairNo',
      type: 'searchTableSpec',
      searchType: 'repairOrder',
      currentValue: ctx.baseFormData.repairNo,
      extraData: {
        dispatchFlag: 20,
        auditStatus: '03',
        repairCompanyNo: ctx.userInfo.companyCode,
      },
      changeMethod: 'changeMethod',
      isMultiple: true,
      isHidden: ctx.baseFormData.relatedRepairFlag == '0',
    },
    {
      name: '接单人',
      prop: 'receivePersonName',
      type: 'input',
      key: 'receivePersonName',
    },
    {
      name: '联系电话',
      prop: 'contactPhone',
      key: 'contactPhone',
      type: 'input',
    },
    {
      name: '计划完工日期',
      prop: 'planCompleteDate',
      type: 'date',
    },
    {
      name: '实施方式',
      prop: 'executeMode',
      type: 'select',
      options: ctx.setOptions.executeMode || [],
    },
    {
      name: '备注',
      prop: 'remark',
      type: 'input',
    },
  ];
};

export const columnListDefault = [
  { type: 'checkbox', title: '', width: 50, disabled: true },
  { type: 'seq', title: '序号', width: 50 },
  {
    field: 'type',
    title: '维修类型',
    visible: true,
    editRender: {
      name: 'ElSelect',
      options: [
        { value: '01', label: '水电' },
        { value: '02', label: '设备' },
        { value: '03', label: '电器' },
        { value: '04', label: '其他' },
      ],
    },
  },
  {
    field: 'location',
    title: '维修地点',
    visible: true,
    editRender: {
      name: 'input',
    },
  },
  {
    field: 'content',
    title: '维修内容',
    visible: true,
    editRender: {
      name: 'input',
    },
  },
  {
    field: 'estimatedCost',
    title: '维修预估费用（元）',
    visible: true,
    editRender: {
      name: 'input',
    },
  },
  {
    field: 'plan',
    title: '维修方案',
    visible: true,
    editRender: {
      name: 'input',
    },
  },
];
// 根据表格条件禁用
export const checkBoxConfig = {
  checkMethod: ({ row }) => {
    return !row.dispatchFlag;
  },
};
